import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

const CarouselButton = (props) => {
  return (
    <Tooltip title={props.desc} placement="bottom-start" followCursor>
      <Button
        className="carousel-button"
        style={{
          color: "white",
          textShadow: "1px 1px 2px black",
          transition: "0.2s",
          backgroundImage: props.img,
        }}
        href={props.link}
        target="_blank"
      >
        {props.text}
      </Button>
    </Tooltip>
  );
};

export default CarouselButton;
